import { render, staticRenderFns } from "./widgetImage.vue?vue&type=template&id=075661ab&scoped=true&"
import script from "./widgetImage.vue?vue&type=script&lang=js&"
export * from "./widgetImage.vue?vue&type=script&lang=js&"
import style0 from "./widgetImage.vue?vue&type=style&index=0&id=075661ab&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "075661ab",
  null
  
)

export default component.exports